import { useState } from 'react'
import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnValue, returnBlockValue } from '@/utils/op-types/helperFunctions'

import Card from '@/components/optypes/frontend/SideScroller/blocks/Card'
import Input from '@/components/optypes/headlesss-components/Input'
import Linker from '@/components/optypes/headlesss-components/Link'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const LinkBlock = ({ id, block, design, content }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  const [autoFocus, setAutoFocus] = useState(false)

  return (
    <Card className="opr-linkblock">
      <div className="opr-card-header">
        <h2 className="text-lg font-bold">
          {returnBlockValue('title', 'content', opBlocks[block], content)}
        </h2>

        <h3 className="text-sm">
          {returnBlockValue('desc', 'content', opBlocks[block], content)}
        </h3>
      </div>

      <div className="mt-4 opr-card-content">
        {returnBlockValue('links', 'content', opBlocks[block], content).map(
          (data, index) => (
            <Linker key={index} data={data.url} className="">
              <div
                className="opr-linkblock-link cursor-pointer hover:shadow-xl rounded p-3 shadow mb-1.5 flex flex-col justify-center md:justify-start md:flex md:flex-row items-center"
                style={{
                  backgroundColor: returnValue(
                    'theme_cardbg',
                    opDesign,
                    pageDesign
                  ),
                  color: returnValue('theme_cardtext', opDesign, pageDesign),
                  borderColor: returnValue(
                    'theme_cardborder',
                    opDesign,
                    pageDesign
                  ),
                }}
              >
                {data.url.meta.img && (
                  <div className="md:mr-4 flex-shrink-0">
                    <img
                      src={data.url.meta.img}
                      alt=""
                      className="w-full mb-3 md:mb-0 md:h-22 md:w-36  rounded shadow"
                    />
                  </div>
                )}
                <div className="w-full md:pr-6 flex-grow">
                  <h2 className="font-bold text-lg">{data.url.meta.title}</h2>
                  <h4 className="font-medium line-clamp-1 text-sm">
                    {data.url.meta.desc}
                  </h4>
                  <p className="font-medium  text-sm text-blue-400 mt-1">
                    {data.url.url}
                  </p>
                </div>
              </div>
            </Linker>
          )
        )}
      </div>
    </Card>
  )
}

export default LinkBlock
